import { Component, computed, inject } from '@angular/core';

import { RouteProgressService } from '@venecia/services';

@Component({
  selector: 'app-route-progress-bar',
  imports: [],
  templateUrl: './route-progress-bar.html',
  styleUrl: './route-progress-bar.scss'
})
export class RouteProgressBar {

  private readonly svc = inject(RouteProgressService);
  loading = computed(() => this.svc.loading());
}
